<template>
  <DatatableReportV3
    title="Sold Line Items"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import { companyNameColumns } from "@/lib/customerTypes";

import CONSTANTS from "@/Constants.js";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        order: [[0, "desc"]],
        columns: [
          {
            data: "invoice_date",
            title: "Invoice Date",
            filterName: "sold_on",
            searchable: false,
            responsivePriority: 6
          },
          ...companyNameColumns(),
          {
            data: "customer",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.customers,
            responsivePriority: 1
          },
          { data: "email", responsivePriority: 12 },
          { data: "phone", responsivePriority: 11 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 14
          },
          { data: "address", orderable: false, responsivePriority: 15 },
          { data: "invoice", responsivePriority: 3 },
          { data: "job", responsivePriority: 10 },
          {
            data: "technician",
            title: "Opp. Owner",
            filterName: "technician_id",
            responsivePriority: 7
          },
          {
            data: "department",
            filterName: "department_id",
            searchable: false,
            responsivePriority: 9
          },
          {
            data: "category",
            filterName: "li_category",
            searchable: false,
            responsivePriority: 8
          },
          {
            data: "line_item",
            title: "Line Item",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.items,
            filterName: "line_item_ids",
            footerClassName: "text-left",
            responsivePriority: 2
          },
          {
            data: "quantity",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.sold,
            searchable: false,
            responsivePriority: 5
          },
          {
            data: "total_price",
            title: "Price",
            className: "text-right",
            footerClassName: "aggregate-currency",
            aggregateTitle: CONSTANTS.AGGREGATE_HEADERS.revenue,
            searchable: false,
            responsivePriority: 4
          },
          {
            data: "price_adjustment",
            title: "Price Adjustment",
            searchable: false,
            orderable: false,
            responsivePriority: 13
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Sold Line Items" });
  }
};
</script>

<style lang="scss" scoped></style>
